// extracted by mini-css-extract-plugin
export default {"carousel":"infinite-carousel-module--carousel--TG7b0"};